import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";

const API = process.env.REACT_APP_API;

const useDeleteDeliveryMethod = () => {
  const fetch = useFetch();
  const queryClient = useQueryClient();

  return useMutation(
    (id: number) => {
      return fetch(`${API}/api/semeadora/delivery-methods-manage/${id}/`, {
        method: "DELETE",
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["delivery-methods"]);
      },
    },
  );
};

export default useDeleteDeliveryMethod;
